<template>
  <div>
    <div class="flex_row_space_between_center">
      <div class="flex_row_start_center">
        <div @click="uploadClick(false)">
          <Upload
            ref="picUploader"
            :show-upload-list="false"
            action="/aries-api/resource/upload"
            :data="uploadPicData"
            multiple
            :before-upload="handlePicBeforeUpload"
            :on-success="handlePicSuccess"
            v-show="doWhat=='edit'"
            style="margin-right:20px"
          >
            <el-button size="small" type="primary">
              上传
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </Upload>
        </div>
        <div @click="uploadClick(true)" v-if="previewList.length>0">
          <Upload
            ref="picChange"
            :show-upload-list="false"
            action="/aries-api/resource/upload"
            :data="uploadPicData"
            multiple
            :before-upload="handlePicBeforeUpload"
            :on-success="chgPicSuccess"
            v-show="doWhat=='edit'"
          >
            <el-button size="small" type="primary">
              替换
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </Upload>
        </div>
        <div v-show="isPIcUploading" style="width:200px;margin-left:10px">
          <Progress :percent="uploadPercent" :status="uploadStatus" />
        </div>
      </div>
      <div class="flex_row_end_center">
        <div v-show="isAudioUploading" style="width:200px">
          <Progress :percent="audioUploadPercent" :status="audioUploadStatus" />
        </div>
        <div v-if="previewList.length>0">
          <el-upload
            action="/aries-api/resource/upload"
            multiple
            accept="audio/mp3"
            :before-upload="onBeforeMultyUploadAudio"
            :on-success="onSuccessMultyUploadAudio"
            :data="uploadAudioData"
            :show-file-list="false"
            v-show="doWhat=='edit'"
          >
            <el-tooltip effect="dark" placement="top-start">
              <div slot="content">
                音频命名规则：
                <br />上传讲解：对应图片p1，音频命名为p1.mp3
                <br />上传原音：对应图片p1，音频命名为1.mp3
              </div>
              <el-button size="small" type="primary" icon="el-icon-upload">批量导入音频</el-button>
            </el-tooltip>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="editor-container clearfix">
      <div class="editor-row clearfix" v-if="previewList.length>0">
        <div class="editor-preview">
          <PreviewList
            :axis="'xy'"
            :lockAxis="'xy'"
            :distance="10"
            :helperClass="'sort-preview'"
            v-model="previewList"
            @sort-end="onPreviewSortEnd($event)"
          >
            <PreviewItem
              v-for="(item, index) in previewList"
              :index="index"
              :key="index"
              :item="item"
              :class="{curr:index===currIndex}"
              :disabled="doWhat=='view'"
              :style="chgMode?'opacity:1':''"
            >
              <div class="flex-img" @click="onSelectThumb(item,index)">
                <div
                  v-for="(img,idx) in item.image"
                  :key="idx"
                  :style="{backgroundImage:`url(${img}`}"
                >
                  <p class="pageNumShow">P{{index+1}}</p>
                </div>
              </div>
              <Icon
                class="pageHiddenShow"
                :type="item.isHidden==1?'ios-eye-off':'ios-eye'"
                size="24"
                :color="item.isHidden==1?'red':'green'"
                @click="hiddenPage(index)"
                v-show="doWhat=='edit'"
              />
              <Poptip
                class="poptip-remove"
                confirm
                title="您确定要删除此页么？"
                :transfer="true"
                @on-ok="onRemovePage(index)"
                v-show="doWhat=='edit'"
              >
                <Icon type="ios-close-circle" size="16" color="#ed4014" />
              </Poptip>
            </PreviewItem>
          </PreviewList>
        </div>
      </div>

      <div class="editor-row clearfix" v-if="chgMode">
        <div class="editor-preview">
          <PreviewList
            :axis="'xy'"
            :lockAxis="'xy'"
            :distance="10"
            :helperClass="'sort-preview'"
            v-model="chgPDFPage"
            @sort-end="onChgSortEnd($event)"
          >
            <PreviewItem
              v-for="(item, index) in chgPDFPage"
              :index="index"
              :key="index"
              :item="item"
              :class="{curr:index===currChgIndex}"
              style="opacity:1"
            >
              <div class="flex-img" @click="onSelectChg(item,index)">
                <div
                  v-for="(img,idx) in item.image"
                  :key="idx"
                  :style="{backgroundImage:`url(${img}`}"
                >
                  <p class="pageNumShow">P{{index+1}}</p>
                </div>
              </div>
              <Poptip
                class="poptip-remove"
                confirm
                title="您确定要删除此页么？"
                :transfer="true"
                @on-ok="onRemoveChgPage(index)"
                v-show="doWhat=='edit'"
              >
                <Icon type="ios-close-circle" size="16" color="#ed4014" />
              </Poptip>
            </PreviewItem>
          </PreviewList>
        </div>
        <div class="oidFlex">
          <a
            class="upArrow"
            href="javascript:;"
            @click="arrowHandle('up')"
            style="margin-right:10px"
          >
            <Icon type="md-arrow-up" size="20" color="#555555" />
          </a>
          <a class="downArrow" href="javascript:;" @click="arrowHandle('down')">
            <Icon type="md-arrow-down" size="20" color="#555555" />
          </a>
          <el-button type="primary" @click="confirmChg" style="margin-left:30px">确定替换</el-button>
          <el-button @click="cancelChg">取消替换</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ApiMessage } from "@/utils/util";
import PreviewList from "./PreviewList";
import PreviewItem from "./PreviewItem";
import {
  /*getOrientation,
  dataURLtoFile,
  rotateImage,*/
  checkFormat,
  SortLikeWin,
} from "../../book";
export default {
  name: "PreviewBar",
  components: {
    PreviewList,
    PreviewItem,
  },
  data() {
    return {
      //currIndex: null,
      previewList: [],
      uploadPicData: {
        isOnlyMP3: "false",
        pdfToPng: "true",
        retainPdf: "true",
      },
      picUploadNum: 0,
      uploadPercent: 0,
      uploadStatus: "active",
      isPIcUploading: false,
      everyProgress: 0,
      timer: "",
      pdfUpload: false,
      imageUpload: false,
      showPageNum: 0,
      pageTemp: [],
      chgPDFaddress: "",
      chgImagePageTemp: [],
      chgPDFPageTemp: [],
      chgPDFPage: [],
      currChgIndex: null,
      chgMode: this.pdfChgMode,
      chgEnter: false,
      uploadAudioData: {
        isOnlyMP3: "true",
        pdfToPng: "false",
        retainPdf: "false",
      },
      audioUploadNum: 0,
      audioEveryProgress: 0,
      audioUploadPercent: 0,
      audioUploadStatus: "active",
      isAudioUploading: false,
    };
  },
  props: {
    currIndex: {
      type: Number,
      default: null,
    },
    book: {
      type: Object,
      default: null,
    },
    doWhat: {
      type: String,
      default: "",
    },
    pdfChgMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {
    book(newVal, oldVal) {
      console.log("new book found");
      console.log(newVal);
      if (newVal.content.pages != undefined) {
        this.previewList = newVal.content.pages;
        if (this.previewList.length > 0) {
          this.onSelectThumb(
            this.previewList[this.showPageNum],
            this.showPageNum
          );
        }
      }
    },
    pdfChgMode(newVal, oldVal) {
      this.chgMode = newVal;
      if (!this.chgMode) {
        this.chgPDFPage = [];
        this.chgPDFaddress = "";
      }
    },
  },
  methods: {
    // 预览图排序回调
    onPreviewSortEnd(event) {
      if (this.doWhat === "edit") {
        let newIdx = event.newIndex;
        let oldIdx = event.oldIndex;
        this.$Modal.confirm({
          title: "确认调整顺序？",
          content: "",
          onOk: () => {
            this.showPageNum = oldIdx;
            this.$emit("previewHandle", "resort", this.previewList);
          },
          onCancel: () => {
            let temp = this.previewList[newIdx];
            this.$set(this.previewList, newIdx, this.previewList[oldIdx]);
            this.$set(this.previewList, oldIdx, temp);
          },
        });
      }
      console.log(event);
    },
    onSelectThumb(item, idx) {
      if (item.readPoints != undefined) {
        let len = item.readPoints.length;
        for (let i = 0; i < len; ++i) {
          if (item.readPoints[i].position == undefined) {
            item.readPoints.splice(i, 1);
          }
        }
      }
      this.showPageNum = idx;
      this.$emit("update:currIndex", idx);
      this.$emit("previewHandle", "select", item);
    },
    hiddenPage(index) {
      console.log(index);
      this.$emit("previewHandle", "hidden", index);
    },
    getTimer() {
      //单个pdf上传才开启定时器，如果多个pdf则马上关闭定时器
      if (this.picUploadNum == 1) {
        this.uploadPercent += 1;
        if (this.uploadPercent > 80) {
          clearInterval(this.timer);
        }
      } else {
        clearInterval(this.timer);
      }
    },
    uploadClick(param) {
      this.chgEnter = param;
    },
    handlePicBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        this.uploadPercent = 0;
        if (
          this.chgEnter &&
          !this.chechName(file.name) &&
          checkFormat(file, "picture")
        ) {
          ApiMessage(this, `${file.name}命名不是“P+页码”`, "error");
          //this.isPIcUploading = false;
          reject();
        } else {
          if (file.type === "application/pdf") {
            this.pdfUpload = true;
            this.imageUpload = false;
            this.picUploadNum += 1;
            this.everyProgress = parseInt(100 / this.picUploadNum);
            this.isPIcUploading = true;
            this.timer = setInterval(this.getTimer, 500);
            resolve(file);
          } else {
            this.pdfUpload = false;
            if (!checkFormat(file, "picture")) {
              ApiMessage(this, `${file.name}上传文件格式错误”`, "error");
              reject();
            } else {
              this.imageUpload = true;
              this.picUploadNum += 1;
              this.everyProgress = parseInt(100 / this.picUploadNum);
              this.isPIcUploading = true;
              //先判断是jpeg再获取jpeg的旋转参数
              const type = file.type.split("/")[1];
              resolve(file);
              // if (type === "jpg" || type === "jpeg") {
              //   getOrientation(file).then((orient) => {
              //     console.log(orient);
              //     if (orient && orient >= 3) {
              //       let reader = new FileReader();
              //       let img = new Image();
              //       reader.onload = (e) => {
              //         img.src = e.target.result;
              //         img.onload = function () {
              //           const data = rotateImage(
              //             img,
              //             img.width,
              //             img.height,
              //             orient
              //           );
              //           const newFile = dataURLtoFile(data, file.name);
              //           resolve(newFile);
              //         };
              //       };
              //       reader.readAsDataURL(file);
              //     } else {
              //       resolve(file);
              //     }
              //   });
              // } else {
              //   resolve(file);
              // }
            }
          }
        }
      });
    },
    handlePicSuccess(response, file, fileList) {
      console.log(response);
      if (response.result == 0) {
        if (this.book.content.pages === undefined) {
          this.book.content.pages = [];
        }
        let len = response.data.length;
        let i = 0;
        if (this.pdfUpload == true) {
          i = 1;
          this.book.content.pdf = response.data[0].url;
        }
        for (; i < len; ++i) {
          let imageList = [];
          imageList.push(response.data[i].url);
          let nameTemp = "";
          if (response.data[i].pdfName != undefined) {
            nameTemp =
              response.data[i].pdfName.split(".")[0] +
              "-" +
              response.data[i].name;
          } else {
            nameTemp = response.data[i].name;
          }
          let pageParam = {
            name: nameTemp, //response.data[i].name,
            image: imageList,
          };
          this.pageTemp.push(pageParam);
        }
        this.picUploadNum -= 1;
        this.uploadPercent += this.everyProgress;
        if (this.picUploadNum === 0) {
          this.uploadPercent = 100;
          this.uploadStatus = "success";
          this.pageTemp.sort(SortLikeWin("name"));
          this.showPageNum = 0;
          this.$emit("previewHandle", "addPage", this.pageTemp);
          this.pageTemp = [];
          this.pdfUpload = false;
          this.imageUpload = false;
        }
      } else {
        this.picUploadNum = 0;
        this.uploadPercent = 100;
        this.uploadStatus = "wrong";
        this.pageTemp = [];
        this.pdfUpload = false;
        this.imageUpload = false;
        alert(response.msg);
        return;
      }
    },
    chechName(name) {
      let nameTemp = name.split(".")[0].substr(1);
      let result = /^\d+$/.test(nameTemp);
      return result;
    },
    onRemovePage(idx) {
      if (idx == 0) {
        if (this.previewList.length == 1) {
          this.showPageNum = 0;
        } else {
          this.showPageNum = idx;
        }
      } else {
        this.showPageNum = idx - 1;
      }
      this.$emit("previewHandle", "delete", idx);
    },

    chgPicSuccess(response, file, fileList) {
      console.log(response);
      let len = response.data.length;
      if (response.result == 0) {
        if (this.imageUpload) {
          let nameTemp = response.data[0].name.split(".")[0].substr(1);
          let pageParam = {
            name: nameTemp,
            url: response.data[0].url,
          };
          this.chgImagePageTemp.push(pageParam);
        } else if (this.pdfUpload) {
          this.chgPDFaddress = response.data[0].url;
          for (let i = 1; i < len; ++i) {
            let imageList = [];
            imageList.push(response.data[i].url);
            let nameTemp = "";
            if (response.data[i].pdfName != undefined) {
              nameTemp =
                response.data[i].pdfName.split(".")[0] +
                "-" +
                response.data[i].name;
            } else {
              nameTemp = response.data[i].name;
            }
            let pageParam = {
              name: nameTemp,
              image: imageList,
            };
            this.chgPDFPageTemp.push(pageParam);
          }
        }

        this.picUploadNum -= 1;
        this.uploadPercent += this.everyProgress;
        if (this.picUploadNum === 0) {
          this.uploadPercent = 100;
          this.uploadStatus = "success";

          if (this.imageUpload) {
            this.$emit("previewHandle", "chgPageImage", this.chgImagePageTemp);
            this.chgImagePageTemp = [];
            this.imageUpload = false;
          } else if (this.pdfUpload) {
            this.chgPDFPageTemp.sort(SortLikeWin("name"));
            for (let i in this.chgPDFPageTemp) {
              this.chgPDFPage.push(this.chgPDFPageTemp[i]);
            }
            this.chgMode = true;
            this.$emit("update:pdfChgMode", this.chgMode);
            this.chgPDFPageTemp = [];
            this.pdfUpload = false;
            console.log(this.chgPDFPage);
          }
        }
      } else {
        this.picUploadNum = 0;
        this.uploadPercent = 100;
        this.uploadStatus = "wrong";
        this.chgPDFPageTemp = [];
        this.chgImagePageTemp = [];
        this.pdfUpload = false;
        this.imageUpload = false;
        alert(response.msg);
        return;
      }
    },
    onChgSortEnd(event) {
      if (this.doWhat === "edit") {
        let newIdx = event.newIndex;
        let oldIdx = event.oldIndex;
        this.$Modal.confirm({
          title: "确认调整顺序？",
          content: "",
          onOk: () => {},
          onCancel: () => {
            let temp = this.chgPDFPage[newIdx];
            this.$set(this.chgPDFPage, newIdx, this.chgPDFPage[oldIdx]);
            this.$set(this.chgPDFPage, oldIdx, temp);
          },
        });
      }
    },
    onSelectChg(item, idx) {
      this.currChgIndex = idx;
    },
    onRemoveChgPage(idx) {
      this.chgPDFPage.splice(idx, 1);
    },
    confirmChg() {
      this.$emit("previewHandle", "chgPagePDF", [
        this.chgPDFPage,
        this.chgPDFaddress,
      ]);
    },
    cancelChg() {
      this.chgPDFPage = [];
      this.chgPDFaddress = "";
      this.chgMode = false;
      this.$emit("update:pdfChgMode", this.chgMode);
    },
    arrowHandle(dir) {
      if (dir == "up") {
        if (this.currChgIndex != null) {
          this.$emit("previewHandle", "chgPDFInsertPage", [
            this.chgPDFPage[this.currChgIndex],
            this.currChgIndex,
          ]);
        } else {
          alert("请先在下方选择书页");
          return;
        }
      } else if (dir == "down") {
        if (this.currIndex != null) {
          this.chgPDFPage.splice(
            this.currIndex,
            0,
            this.book.content.pages[this.currIndex]
          );
        } else {
          alert("请先在上方选择书页");
          return;
        }
      }
    },
    onBeforeMultyUploadAudio(file) {
      this.audioUploadNum += 1;
      this.audioEveryProgress = parseInt(100 / this.audioUploadNum);
      this.audioUploadPercent = 0;
      this.isAudioUploading = true;
      this.audioUploadStatus = "active";
    },
    onSuccessMultyUploadAudio(response, file, fileList) {
      if (response.result != 0) {
        alert(file.name + response.msg);
        this.audioUploadNum -= 1;
        this.audioUploadPercent += this.audioEveryProgress;
        return;
      }
      let fileName = response.data[0].name.split(".")[0].toLowerCase();
      let url = response.data[0].url;
      let duration = response.data[0].length;

      if (/^[p]\d+$/.test(fileName)) {
        this.editPointInteract(fileName, url, duration);
      } else if (/^\d+$/.test(fileName)) {
        this.multyChgAudio(fileName, url, duration);
      } else {
        this.multyMatchAudioInteraceOnly(fileName, url, duration);
      }
      this.audioUploadNum -= 1;
      this.audioUploadPercent += this.audioEveryProgress;
      if (this.audioUploadNum === 0) {
        this.audioUploadPercent = 100;
        this.audioUploadStatus = "success";
        this.$emit("previewHandle", "multyAudio", null);
      }
    },
    multyMatchAudioInteraceOnly(fileName, url, duration) {
      let foundItem = false;
      let pageLen = this.book.content.pages.length;
      for (let i = 0; i < pageLen; ++i) {
        let page = this.book.content.pages[i];
        if (page.readPoints != undefined) {
          let pointLen = page.readPoints.length;
          for (let j = 0; j < pointLen; ++j) {
            if (fileName == page.readPoints[j].name.toLowerCase()) {
              foundItem = true;
              let temp = {
                id: "1",
                type: "audio",
                config: {
                  content: url,
                  duration: duration,
                },
              };
              page.readPoints[j].scripts = [];
              page.readPoints[j].scripts.push(temp);
              break;
            }
          }
        }
      }
      if (!foundItem) {
        console.log("multyMatchAudioInteraceOnly:not found " + fileName);
      }
    },
    multyChgAudio(fileName, url, duration) {
      let generateNew = false;
      let index = Number(fileName);
      let pageLen = this.book.content.pages.length;
      if (index <= pageLen) {
        console.log(index);
        let page = this.book.content.pages[index - 1];
        if (page.readPoints == undefined) {
          page.readPoints = [];
        }
        if (page.readPoints.length == 0) {
          generateNew = true;
        } else if (page.readPoints.length > 0) {
          let pointLen = page.readPoints.length;
          generateNew = true;
          for (let j = 0; j < pointLen; ++j) {
            page.readPoints[j].audio = url;
            page.readPoints[j].duration = duration;
            if (page.readPoints[j].apply_type != 2) {
              generateNew = false;
            }
          }
        }
        if (generateNew) {
          this.createNewPoint(page.readPoints, url, duration, null, index);
        }
        console.log(page.readPoints);
      }
    },
    editPointInteract(fileName, url, duration) {
      let generateNew = false;
      let index = Number(fileName.slice(1));
      let pageLen = this.book.content.pages.length;
      if (index <= pageLen) {
        console.log(index);
        let page = this.book.content.pages[index - 1];
        let temp = {
          id: "1",
          type: "audio",
          config: {
            content: url,
            duration: duration,
          },
        };
        if (page.readPoints == undefined) {
          page.readPoints = [];
        }
        if (page.readPoints.length == 0) {
          generateNew = true;
        } else if (page.readPoints.length > 0) {
          generateNew = true;
          let pointLen = page.readPoints.length;
          for (let j = 0; j < pointLen; ++j) {
            page.readPoints[j].scripts = [];
            page.readPoints[j].scripts.push(temp);
            if (page.readPoints[j].apply_type != 2) {
              generateNew = false;
            }
          }
        }
        if (generateNew) {
          this.createNewPoint(page.readPoints, "", null, temp, index);
        }
      }
    },
    createNewPoint(point, audio, duration, scriptsObj, index) {
      let pointTemp = {
        name: `p${index}-new`,
        OID: "",
        positionDesc: "",
        text: "",
        audio: audio,
        duration: duration,
        video: "",
        game: "",
        scripts: [],
        role: "",
        emotion: "",
        apply_type: 0,
        page: 1,
        position: ["rect", 100, 100, 100, 100, true],
      };
      if (scriptsObj != null) {
        pointTemp.scripts.push(scriptsObj);
      }
      point.push(pointTemp);
    },
  },
};
</script>

<style lang="less">
@import "../../../fyd-style.less";
</style>


// WEBPACK FOOTER //
// PreviewBar.vue?51ce3035